// extracted by mini-css-extract-plugin
export default {"userCell":"styles_userCell__RhRnv","commonCell":"styles_commonCell__hREef","truncateCell":"styles_truncateCell__HvExH","CommonCell":"styles_CommonCell__3seJ+"};